import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AddClinicComplaints } from "../../services/PlansAndProcedure";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};
// const complaintsSchema = yup
  // .object({
    // speciality: yup.string().required("This Field Required"),
    // complaints: yup.array().of(yup.string()).min(1, 'At least one option is required'),
  // })
  // .required();
// schemaaa chnage

const AddComplaints = ({ specialities, setSpecialities }) => {
  const [open, setOpen] = useState(false);
  const [complaints, setComplaints] = useState([]);
  const [specialitiesOption, setSpecialitiesOption] = useState("");
  const [specialityErrorMsg,setSpecialityErrorMsg]=useState();
  const [complaintErrorMsg,setComplaintErrorMsg]=useState();
  const [isSubmitting,setIsSubmitting]=useState(false);
  const token = JSON.parse(localStorage.getItem("token"));
  const username = token?.username;


  const onTagsChange = (event, values) => {
    setComplaints(values);
    // console.log("values", values);
    if(values.length>0){
      setComplaintErrorMsg()
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSpecialitiesOption("")
    setComplaints([]);
    setComplaintErrorMsg();
    setSpecialityErrorMsg();
    setIsSubmitting(false)
  };

  const handleSubmit = async (event) => {
    event.preventDefault()

    if(specialitiesOption==="" || complaints.length===0){
      if(specialitiesOption===""){
        setSpecialityErrorMsg("This Field is Required")
      }else{
        setSpecialityErrorMsg()
      }
      if(complaints.length===0){
        setComplaintErrorMsg("This Field is Required")
      }else{
        setComplaintErrorMsg()
      }
    }
    else{
      const formdata = {
            speciality: specialitiesOption,
            createdBy: username,
            values: complaints,
          };
          console.log(formdata)
          try {
                setIsSubmitting(true)
                await AddClinicComplaints(formdata)
                handleClose();
                toast.success("Complaints Submitted Sucessfully", {
                  position: toast.POSITION.TOP_RIGHT,
                });
              } catch (error) {
                console.log(error.message)
                toast.error("Please Check Your Server", {
                  position: toast.POSITION.TOP_RIGHT,
                });
                setIsSubmitting(false)
            }
    }
    
  };

 
  return (
    <div>
      <Button
        sx={{
          backgroundColor: "#2d256c!important",
          textAlign: "center",
          color: "#FFFFFF",
          textTransform: "capitalize",
          fontSize: "12px",
          padding: "8px 15px",
          "&:hover": { backgroundColor: "#2d256c!important" },
        }}
        size="small"
        type="submit"
        onClick={handleOpen}
      >
        Add Complaints
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            sx={{ textAlign: "center",fontSize:"17px" }}
            variant="h5"
            component="h2"
          >
            Add Complaints
          </Typography>
          <form onSubmit={handleSubmit}>
            <Typography sx={{ fontWeight: "bold", mt: "10px",fontSize:"14px" }}>
              Select Speciality
            </Typography>
            <Select
              placeholder="Select"
              size="small"
              className="inputbox"
              onChange={(e)=>{
                setSpecialitiesOption(e.target.value);
                console.log(e.target.value)
                setSpecialityErrorMsg()
              }}
              fullWidth
            >
              <MenuItem value=""></MenuItem>
              {specialities.map((el, id) => {
                return (
                  <MenuItem key={id} value={el.speciality}>
                    {el.speciality}
                  </MenuItem>
                );
              })}
            </Select>
            {
              specialityErrorMsg &&
              <span style={{ color: "red" }} className="error">
              {specialityErrorMsg}
              </span>
            }
            <Typography sx={{ fontWeight: "bold", mt: "10px",fontSize:"14px" }}>
              Complaints (Press Enter after every entry)
            </Typography>
            <Autocomplete
              multiple
              freeSolo
              options={[]}
              onChange={onTagsChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
            />
            {
              complaintErrorMsg &&
              <span style={{ color: "red" }} className="error">
              {complaintErrorMsg}
              </span>
            }
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <button
                style={{
                  background: "#696969",
                  color: "white",
                  border: "none",
                  padding: "8px 15px",
                  borderRadius: "3px",
                  fontSize:"12px",
                  cursor:"pointer"
                }}
                type="reset"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                disabled={isSubmitting}
                style={{
                  background: isSubmitting?"#898989":"#D83F87",
                  color: "white",
                  border: "none",
                  padding: "8px 15px",
                  borderRadius: "3px",
                  fontSize:"12px",
                  cursor: isSubmitting?"default":"pointer"
                }}
                type="submit"
              >
                Submit
              </button>
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default AddComplaints;
